
























































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import FileUpload from '@/components/FileUpload.vue';
import DocPreviewDialog from '@/components/DocPreviewDialog.vue';
import { api } from '@/api';

@Component({
  components: {
    FileUpload,
    DocPreviewDialog
  }
})
export default class ReportFileTable extends Mixins(CommonMixin) {
  // Props
  @Prop(String) public readonly label!: string;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop(String) public readonly apiParentUrl!: string;
  @Prop({ type: String, default: '3' }) public readonly labelCols!: string;
  @Prop({ type: String, default: '9' }) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;

  public curItem: object|null = null;
  public dialogDelete = false;
  public dialogUpload = false;
  public apiFileUrl(id: number|null) { return this.apiParentUrl + '/' + this.field + (id ? '/' + id : ''); }

  public previewFile(id: number) {
    const ref: any = this.$refs.docpreview;
    ref.open(this.apiFileUrl(id));
  }
  public downloadFile(id: number) {
    api.downloadFile(this.$store, this.apiFileUrl(id));
  }
  public async deleteFile(item) {
    const result = await api.deleteRecord(this.$store, this.apiFileUrl(item.id));
    if (result) {
      this.$set(this.rec, this.field, result.data);
    }
  }
  public async handleUploadedFiles(frec) {
    this.$set(this.rec, this.field, frec);
    this.dialogUpload = false;
  }


}
